export enum ModuleTokens {
  Name = 'clientsBase'
}
